import React from 'react';
import PropTypes from 'prop-types';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { SCROLL_DURATION } from 'site-modules/shared/constants/sub-navigation';
import { ABOUT_INCENTIVES_CONTENT_PATH } from 'site-modules/shared/constants/incentives';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { CollapsedLongContent } from 'site-modules/shared/components/collapsed-long-content/collapsed-long-content';

import './about-incentives-content.scss';

function AboutIncentivesContentUI({ content = null, containerId, collapseLongItems = false }) {
  if (!content) {
    return null;
  }

  const aboutItems = content.children().map(aboutItem => ({
    id: aboutItem.id,
    htmlContent: (
      <CollapsedLongContent content={aboutItem.metadata('htmlContent').value()} isEnabled={collapseLongItems} />
    ),
    heading: aboutItem.metadata('heading').value(),
  }));

  return (
    <div className="about-incentives-content text-gray-darker">
      <CollapsedLongContent content={content.metadata('htmlContent').value()} isEnabled={collapseLongItems} />
      <nav aria-label="jump links" className="about-nav my-2">
        <ul className="list-unstyled d-inline">
          {aboutItems.map(({ id, heading }) => (
            <li key={`nav-${id}`} className="nav-item d-inline-block px-1">
              <ScrollLink
                className="text-primary-darker"
                href={`#${id}`}
                to={id}
                scrollConfig={{
                  duration: SCROLL_DURATION,
                  smooth: true,
                  containerId,
                }}
              >
                {heading}
              </ScrollLink>
            </li>
          ))}
        </ul>
      </nav>
      {aboutItems.map(({ id, htmlContent, heading }) => (
        <ScrollElement id={id} key={id}>
          <h2 className="heading-4">{heading}</h2>
          {htmlContent}
        </ScrollElement>
      ))}
    </div>
  );
}

AboutIncentivesContentUI.propTypes = {
  content: CmsEntities.Content,
  containerId: PropTypes.string,
  collapseLongItems: PropTypes.bool,
};

export const AboutIncentivesContent = connectToModel(AboutIncentivesContentUI, {
  content: bindToContent(ABOUT_INCENTIVES_CONTENT_PATH, 'about'),
});
